import React, { Component } from 'react';
import { Layout, Menu, Icon, Spin, message } from 'antd';
import {Parse} from 'parse';
import { Bar } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/ko';

import {FormattedMessage,   injectIntl } from 'react-intl';

import { getMoneyBenefitOfUser, getValidLastMoneyDate } from '../../utils/fetchDataFromDB';
import { getArraysBetweenTwoDates } from '../../utils/getDateInfo';

import ReportNav from '../../components/navigation/ReportNav';
import Headline from '../../components/Headline';
import RateViewer from '../../components/RateViewer';

import { DateIcon } from '../../components/CustomIcon';

import '../../styles/Mypage.css'

require('../../utils/customizedChart.js');

const { Content } = Layout;


let moneyChartDataForm =  {
  labels: [],
  datasets : [{
    data : [],
    label : 'revenue',
    backgroundColor: '#e3c3ff',
    hoverBackgroundColor : '#a202ff',
    barThickness : 12,
  }]
}

const last12months = moment(new Date()).subtract(12,'months').format('YYYYMM');

class Revenue extends Component{

  constructor(props){
    super(props);
    this.state={
      loading : true,
      monthRevenue: 0, //지난달 수익
      twoMonthAgoRevenue : 0, //두달 전 수익
      accRevenue : 0, // 누적 수익
      moneyData :{}, //월 별 수익 추이
      startedYear : moment().format('YYYY'), //월별 수익 추이에서 볼 수 있는 시작 년도  
      selectedRangeOfChart : 'last12Months',
      validLastDate : moment().format( props.intl.locale === 'ko' ? 'M' :'MMMM')
    }
  }


  async componentDidMount(){
    const locale = this.props.intl.locale; 
    let moneyData = {};
    let validLastDate = this.props.validLastDate;
    try{
      moneyData = await getMoneyBenefitOfUser(Parse.User.current());
      validLastDate = await getValidLastMoneyDate();
    }catch(err){
      message.error("Sorry, There was an error while loading data. Please try again.🙏");
      this.setState({loading : false});   
      return;
    }
    const { moneyBenefitData, accRevenue } = moneyData; 
    
    
    //moment 언어 설정
    moment.locale(locale);

    
    //chart 데이터 삭제
    removeChartData();

    moneyBenefitData.forEach((value, key) => {
      //최근 12개월만 데이터 추가
      if(key > last12months){
        addChartData(key, value, locale);
      }
    })
    
    const prevMonth = moment(validLastDate, 'YYYYMM').subtract(1,'months').format('YYYYMM');
    const revenueOfValidLastDate = moneyBenefitData.get(validLastDate);
    const revenueOfPrevMonth = moneyBenefitData.get(prevMonth);
      
    const startedYear = moment(moneyBenefitData.keys().next().value, 'YYYYMM').format('YYYY');
    
    this.setState({
      validLastDate,
      loading : false,
      monthRevenue : revenueOfValidLastDate,
      twoMonthAgoRevenue : revenueOfPrevMonth,
      startedYear : startedYear,
      accRevenue : accRevenue, 
      moneyData : moneyData
    })

    //chart 업데이트
    this.reference.chartInstance.update();

  }

  componentDidUpdate(prevProps, prevState) {
    const { moneyData, selectedRangeOfChart } = this.state;
    const { locale } =this.props.intl;

    //선택된 년도 변경 시 데이터 변경
    if(selectedRangeOfChart !== prevState.selectedRangeOfChart ){
      //chart의 데이터 삭제
      removeChartData();

      if(selectedRangeOfChart === 'last12Months'){
        moneyData.moneyBenefitData.forEach((value, key) =>  
          key > last12months ? addChartData(key, value, locale) : null
        )
      } else {
        moneyData.moneyBenefitData.forEach((value, key) =>  
          key.startsWith(selectedRangeOfChart) ? addChartData(key, value, locale) : null
        )
      }
    }

    //차트 업데이트
    this.reference.chartInstance.update();
  }

  render(){
    const { locale }=this.props.intl;
    const { loading, monthRevenue, accRevenue, twoMonthAgoRevenue, selectedRangeOfChart, validLastDate, startedYear } = this.state;

    const moneyChartOption = {
      maintainAspectRatio: false,
      cornerRadius: 12,
      fullCornerRadius: true, 
      scales: {
        xAxes: [{
          gridLines: {
            display:false
          }
        }],
        yAxes: [{
          ticks : {
            display: false //y축 라벨 데이터 숨기기
          },
          gridLines: {
            display: false, //배경 gridline 숨기기
          }   
        }]
      },
      tooltips : {
        titleFontFamily : 'NotoSans',
        titleFontSize : 14,
        titleFontStyle : 'normal',
        bodyFontFamily : 'NotoSans-Bold',
        bodyFontSize : 14,
        xPadding: 15,
        yPadding: 15,
        displayColors : false,
        backgroundColor : 'rgba(64, 64, 64, 0.8)',
        custom : (tooltip) => customTooltipFunc(tooltip, selectedRangeOfChart)
      }
      
    }

    return(
    <Spin spinning={loading} tip="Loading..." wrapperClassName="loading-style">
      <Layout style={{ background: '#fff' }}>
        <ReportNav selectedKey={"revenue"}/>
        <Content style={{margin:20}}>
          <Headline id="Report.revenue.headline" defaultMessage="Revenue"/>
          <div className="content-margin">
          <p className="report-title">
            <FormattedMessage
              id="Report.revenue.revenueReport"
              defaultMessage="Revenue Report"
              />
          </p>
          <RevenueReportView 
            monthRevenue = {monthRevenue}
            twoMonthAgoRevenue={twoMonthAgoRevenue}
            accRevenue = {accRevenue}
            locale={locale}
            validLastDate={validLastDate}
          />
          <p className="report-title">
            <FormattedMessage
              id="Report.revenue.monthlyRevenueTrend"
              defaultMessage="Monthly Revenue"
              />
          </p>
          <div className="revenue-report-chart-wrapper">
            <Menu 
              mode="horizontal"
              style={{display:'felx'}}
              defaultSelectedKeys={['last12Months']}
              onClick={(e) => {
                console.log(e);
                this.setState({ selectedRangeOfChart : e.key})
              }}
            >
              <Menu.Item key="last12Months">
                <FormattedMessage
                  id="Report.revenue.last12months"
                  defaultMessage="Last 12 Months"
                />
              </Menu.Item>
              <Menu.SubMenu
                title= {
                  <div className="submenu-title-wrapper revenue-menu">
                    <DateIcon/> 
                    {
                      selectedRangeOfChart === 'last12Months' ? 
                        moment(new Date()).format('YYYY') : selectedRangeOfChart
                    }
                    <Icon type="down" />
                  </div>
                }
              >
                {
                  getArraysBetweenTwoDates( new Date(startedYear), new Date(), 'year')
                  .map(year => 
                    <Menu.Item key={moment(year).format('YYYY')}>
                      {moment(year).format('YYYY')}
                    </Menu.Item>
                  )
                }
              </Menu.SubMenu>

            </Menu>
            <div className="revenue-report-chart-box">
              <Bar
                data={moneyChartDataForm}
                legend={{display: false}}
                ref = {ref => this.reference = ref}
                options={moneyChartOption}
              />
            </div>
          </div>
          <Link to="/mypage/remittance-request">
            <img src={require(`../../img/cta/revenue_${locale}@2x.png`).default} alt="cta-button" className="report-cta-btn"/>
          </Link>
          </div>

        </Content>
      </Layout>
    </Spin>
    )
  }


}
  
Revenue=injectIntl(Revenue);

const RevenueReportView = ({monthRevenue, twoMonthAgoRevenue, accRevenue, locale, validLastDate }) => (
  <div className="revenue-report-wrapper">
    <div className="revenue-report-box">
      <p className="revenue-report-title">
        <FormattedMessage id="Report.revenue.monthlyRevenue" defaultMessage="Revenue in {month}"
        values={{month : moment(validLastDate, 'YYYYMM').format( locale === 'ko' ? 'M' :'MMMM') }}/>
      </p>
      <div className="revenue-report-money-wrapper">
        <div className="revenue-report-money">{numberFormat(monthRevenue, 2, 2)}</div>
        <RateViewer prevValue={twoMonthAgoRevenue} currValue={monthRevenue} integerFontSize={24} decimalFontSize={18}/>
      </div>
    </div>
    <div className="revenue-report-box">
      <p className="revenue-report-title">
        <FormattedMessage id="Report.revenue.accumulationRevenue" defaultMessage="Total Revenue"/>
      </p>
      <div className="revenue-report-money-wrapper">
        <div className="revenue-report-money">{numberFormat(accRevenue, 2, 2)}</div>
      </div>
    </div>
  </div>
);


const removeChartData = () => {
  //chart의 데이터 삭제
  moneyChartDataForm.labels.splice(0,  moneyChartDataForm.labels.length);
  moneyChartDataForm.datasets[0].data.splice(0, moneyChartDataForm.datasets[0].data.length);
}

const addChartData = (yyyymmLabel, data, locale) =>{
  const formatType = locale === 'ko' ? 'MMMM' : 'MMM';
  
  const mmLabel = moment(yyyymmLabel, 'YYYYMM').format(formatType);
  moneyChartDataForm.labels.push(mmLabel);
  moneyChartDataForm.datasets[0].data.push(data);
}

const customTooltipFunc = (tooltip, selectedRangeOfChart) => {
  
  if (!tooltip) { return }

  if (tooltip.body) {

    let dataYearString = moment().format('YYYY');
    
    tooltip.body.forEach((body, idx) => {
      body.lines[idx] = '$ ' + numberFormat(tooltip.dataPoints[idx].value, 2, 2);

      const month = tooltip.dataPoints[idx].label;

      if(selectedRangeOfChart === 'last12Months') {
        //현재 달과 날짜의 달의 차이가 0보다 클때는 같은 년도. 작을때는 이전년도
        dataYearString =  moment().diff(moment(month, 'MMM'), 'months') > 0 ?  dataYearString: dataYearString - 1;

      }else {
        dataYearString = selectedRangeOfChart;
      }
      
      tooltip.title[idx] = month.endsWith('월') ? dataYearString+'년 '+month : month+'. '+dataYearString
    });

  }
}

function numberFormat ( number, maxFractionDigits, minimumFractionDigits) {
  return Number(number).toLocaleString(undefined, {...maxFractionDigits, minimumFractionDigits})
}

export default Revenue;
